import { useSelector } from 'react-redux';
import { skalTemaSkjules } from '../../../utils/skalSkjules';
import { getVisningsdata } from '../../../reducers';

export const useSkalTemaSkjules = (tema) => {
  const visningsdata = useSelector(getVisningsdata);

  return skalTemaSkjules(tema.barnliste, visningsdata);
};
